import { createFileRoute } from "@tanstack/react-router";
import { UkServicePage, ukHead } from "@/components/site/UkServicePage";

export const Route = createFileRoute("/uk/digital-marketing-for-solicitors")({
  head: () => ukHead("/uk/digital-marketing-for-solicitors"),
  component: () => <UkServicePage path="/uk/digital-marketing-for-solicitors" />,
});
